module.exports = __webpack_public_path__ + "img/m-maot-logo.01031aeb.svg";